import React from 'react';
import { FadeIn } from './FadeIn';
import { Check } from 'lucide-react';
export function WhatYouGetSection() {
  const deliverables = [{
    title: 'The 30-Day Launch Roadmap',
    description: 'A step-by-step guide to move from "Scroller" to "Strategist."'
  }, {
    title: 'The 3 Business Profiles to Hunt For',
    description: 'How to spot the businesses most likely to say "Yes" immediately.'
  }, {
    title: 'The "Anti-Cringe" Outreach Script',
    description: 'A no-pressure DM template that gets meetings without sounding like a telemarketer.'
  }, {
    title: 'Micro-Agency Pricing Guide',
    description: 'How to bundle services for $150–$400/month per client.'
  }, {
    title: 'The Teen-Friendly Service Agreement',
    description: 'A simple, one-page contract to keep everything professional.'
  }, {
    title: 'The 30-Minute Daily Profit Workflow',
    description: 'How to batch the work so it never interferes with school or sports.'
  }];
  return <section className="bg-brand-cream py-24 px-6" data-id="element-183">
      <div className="max-w-4xl mx-auto" data-id="element-184">
        <FadeIn data-id="element-185">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-186">
            What You Get
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-187">
          {deliverables.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-188">
              <div className="bg-white p-8 rounded-2xl shadow-sm border border-brand-navy/5 h-full hover:shadow-md transition-shadow" data-id="element-189">
                <div className="flex items-start mb-4" data-id="element-190">
                  <div className="bg-brand-teal/10 p-2 rounded-full mr-4 flex-shrink-0" data-id="element-191">
                    <Check className="w-6 h-6 text-brand-teal" data-id="element-192" />
                  </div>
                  <h3 className="text-xl font-bold text-brand-navy leading-tight pt-1" data-id="element-193">
                    {item.title}
                  </h3>
                </div>
                <p className="text-brand-gray leading-relaxed ml-14" data-id="element-194">
                  {item.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}